import styled from 'styled-components';
import theme from '../../constants/theme';
import { Link } from 'react-router-dom';
import { device } from '../../constants/size';

export const LinkButton = styled(Link)``;

export const StyledButtonNext = styled.button`
	width: 295px;
	height: 66px;
	border-radius: 50px;
	font-weight: 500;
	font-size: 19px;
	line-height: 23px;
	background: ${theme.color.grayBackground};
	color: ${theme.color.white};
	border: 2px solid ${theme.color.bronze};
	box-sizing: border-box;
	box-shadow: 0 0 15px 5px rgba(255, 228, 196, 0.1);
	cursor: pointer;
	transition: 0.3s;

	&:hover {
		transform: scale(1.01);
	}

		
	@media ${device.tablet} {
		font-size: 17px;
		line-height: 21px;
		width: 260px;
		height: 60px;
	}
	
	@media ${device.mobileL} {
		font-size: 15px;
		line-height: 19px;
		width: 240px;
		height: 60px;
	}

	@media ${device.mobileM} {
		font-size: 14px;
		line-height: 18px;
		width: 210px;
		height: 50px;
	}

	@media ${device.mobileS} {
		font-size: 13px;
		line-height: 17px;
		width: 200px;
		height: 40px;
	}
	}
`;
